import api, { API_BASE_URL } from './api';

function apiPath(suffix) {
  const p = suffix.startsWith('/') ? suffix : `/${suffix}`;
  const base = (API_BASE_URL || '').replace(/\/$/, '');
  if (base.endsWith('/api')) {
    return p;
  }
  return `/api${p}`;
}

function unwrapResults(res) {
  const d = res.data;
  if (d && Array.isArray(d.results)) {
    return {
      count: d.count ?? d.results.length,
      results: d.results,
      page: d.page ?? 1,
      page_size: d.page_size ?? d.results.length,
      total_pages: d.total_pages ?? 1,
      next: d.next,
      previous: d.previous,
    };
  }
  if (Array.isArray(d)) return { count: d.length, results: d, page: 1, page_size: d.length, total_pages: 1 };
  return { count: 0, results: [], page: 1, page_size: 0, total_pages: 0 };
}

export async function listCampaigns(params = {}) {
  const res = await api.get(apiPath('/communications/campaigns/'), { params });
  return unwrapResults(res);
}

export async function createCampaign(payload) {
  const res = await api.post(apiPath('/communications/campaigns/'), payload);
  return res.data;
}

export async function getCampaign(id) {
  const res = await api.get(apiPath(`/communications/campaigns/${id}/`));
  return res.data;
}

export async function patchCampaign(id, payload) {
  const res = await api.patch(apiPath(`/communications/campaigns/${id}/`), payload);
  return res.data;
}

export async function deleteCampaign(id) {
  await api.delete(apiPath(`/communications/campaigns/${id}/`));
}

export async function previewCampaign(id) {
  const res = await api.post(apiPath(`/communications/campaigns/${id}/preview/`));
  return res.data;
}

export async function sendCampaign(id) {
  const res = await api.post(apiPath(`/communications/campaigns/${id}/send/`));
  return res.data;
}

/** Paginated JSON deliveries: `{ count, page, page_size, total_pages, results }` */
export async function listDeliveries(campaignId, params = {}) {
  const res = await api.get(apiPath(`/communications/campaigns/${campaignId}/deliveries/`), { params });
  const d = res.data || {};
  const results = Array.isArray(d.results) ? d.results : Array.isArray(d) ? d : [];
  return {
    results,
    count: d.count ?? results.length,
    page: d.page ?? 1,
    page_size: d.page_size ?? results.length,
    total_pages: d.total_pages ?? 1,
    next: d.next,
    previous: d.previous,
  };
}

export async function downloadDeliveriesCsv(campaignId) {
  const res = await api.get(apiPath(`/communications/campaigns/${campaignId}/deliveries/`), {
    params: { format: 'csv' },
    responseType: 'blob',
  });
  return res.data;
}

export async function emergencyBlast(payload) {
  const res = await api.post(apiPath('/communications/campaigns/emergency-blast/'), payload);
  return res.data;
}

/** Fixed position groups — GET returns `[{ key, label }, ...]` */
export async function getStaffPositionGroups() {
  const res = await api.get(apiPath('/communications/staff-positions/'));
  return Array.isArray(res.data) ? res.data : [];
}

/**
 * Employee search for staff-specific audience.
 * @param {{ q?: string, session_id?: number, ids?: string }} params
 */
export async function searchEmployees(params = {}) {
  const res = await api.get(apiPath('/communications/employees/search/'), { params });
  return Array.isArray(res.data) ? res.data : [];
}

export const COMMUNICATION_CATEGORIES = [
  { value: 'school_closure', label: 'School Closure' },
  { value: 'meeting_reminder', label: 'Meeting Reminder' },
  { value: 'emergency', label: 'Emergency' },
  { value: 'policy_update', label: 'Policy Update' },
  { value: 'form_reminder', label: 'Form Reminder' },
  { value: 'general', label: 'General' },
];
